/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
module.exports = {
    tag: 'bear',
    quality: 0.2,
    toughness: 1,
    strength: 1
}